const DEFAULT_DISTANCE_FROM_CONTAINER = 20;
export { DEFAULT_DISTANCE_FROM_CONTAINER };
